import client from 'api/client';

export function updateAssessmentFee(candidateId: string, amount: string, currency?: string) {
    let path = `/assessment/payment/amount`;
    if (candidateId !== null || amount !== null || currency !== null) {
        path += '?';
    }
    if (candidateId !== null && candidateId !== undefined) {
        path += `candidate_id=${candidateId}&`;
    }
    if (amount !== null && amount !== undefined) {
        path += `amount=${amount}&`;
    }
    if (currency !== null && currency !== undefined) {
        path += `currency=${currency}&`;
    }
    return client.put(path);
}
export function updateAssessmentPaymentStatus(candidateId: string, status: string) {
    const url = `/assessment/payment/status?candidate_id=${candidateId}&payment_status=${status}`;
    return client.put(url);
}

export function getAssessmentPayment(candidateId: string) {
    const url = `/assessment/payment?candidate_id=${candidateId}`;
    return client.get(url);
}
